<template>
	<div class="content_main">
		<div class="content_main_top">
			<a-button type="primary" style="margin-right: 5px" @click="show_apply"
				:disabled="selectedRowKeysTabItems.length < 1">申领</a-button>
			<a-input placeholder="品类名称" allowClear v-model="name" class="a_input_self margin_self"
				@keyup.enter.native="serch" />
			<!-- <a-range-picker valueFormat="YYYY-MM-DD" allowClear v-model="date" :placeholder="['采购开始', '采购结束']" /> -->
			<a-button type="primary" style="margin: 5px" @click="serch"> 查询 </a-button>
			<a-button type="primary" ghost @click="result"> 清空 </a-button>
		</div>
		<div class="content_main_center_scroll" id="content_main_center_scroll">
			<a-table :data-source="data" bordered :scroll="{ y: scroll_y }" rowKey="id"
				:row-selection="{ selectedRowKeys: selectedRowKeysTab, onChange: onSelectChangeTab }"
				:pagination="pagination" @change="handleTableChange">
				<a-table-column key="index" title="序号" data-index="index" width="70px">
					<template scope="text, record, index">{{ (pagination.current - 1) * pagination.pageSize + index + 1
					}}</template>
				</a-table-column>
				<!-- <a-table-column key="spu_sn" ellipsis="true" title="物品编号" data-index="spu_sn" /> -->
				<a-table-column key="company_name" ellipsis="true" title="公司名称" data-index="company_name" />
				<!-- <a-table-column key="asset_type" ellipsis="true" title="类别" data-index="asset_type" >
					<span slot="asset_type" slot-scope="text">
					    {{ text ? goodsTypeObj[text] : '' }}
			      	</span>
				</a-table-column> -->
				<a-table-column key="spu_type_name" ellipsis="true" title="类别" data-index="spu_type_name" />
				<a-table-column key="spu_sn" ellipsis="true" title="品类编号" data-index="spu_sn" />
				<a-table-column key="name" ellipsis="true" title="品类名称" data-index="name" />
				<!-- <a-table-column key="name" ellipsis="true" title="物品名称" data-index="name" /> -->
				<a-table-column key="model" ellipsis="true" title="规格型号" data-index="model" />
				<!-- <a-table-column key="amount" ellipsis="true" title="库存数量" data-index="amount" />
				<a-table-column key="unit" ellipsis="true" title="单位" data-index="unit" />
				<a-table-column key="price" ellipsis="true" title="物品单价" data-index="price" /> -->
				<a-table-column key="is_inspected" title="是否检定" data-index="is_inspected">
					<template slot-scope="text, record">
						{{ instrumentMap[record.is_inspected] }}
					</template>
				</a-table-column>
				<a-table-column key="price" ellipsis="true" title="采购均价" data-index="price" />
				<a-table-column key="amount" ellipsis="true" title="库存数量" data-index="amount" />
				<a-table-column key="unit" ellipsis="true" title="单位" data-index="unit" />
				<a-table-column key="action" title="操作" data-index="action" width="100">
					<template scope="text,record">
						<a @click="details(record)">详情</a>
					</template>
				</a-table-column>
			</a-table>
		</div>
		<a-modal v-model="is_apply_show" title="耗材领用-申请" width="60%" :maskClosable="false">
			<template slot="footer">
				<a-button key="back" @click="is_apply_show = false"> 取消 </a-button>
				<a-button key="submit" type="primary" @click="apply_delivery"> 领用出库 </a-button>
			</template>
			<a-form-model :rules="apply_rules" ref="apply_ref" :model="apply_info" :label-col="labelCol"
				:wrapper-col="wrapperCol">
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="物品用途" prop="reason">
							<a-textarea v-model="apply_info.reason" placeholder="如:日常办公"
								:auto-size="{ minRows: 1, maxRows: 3 }" />
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="备　　注">
							<a-textarea v-model="apply_info.remark" placeholder="请输入领用物品的详细说明"
								:auto-size="{ minRows: 1, maxRows: 3 }" />
						</a-form-model-item>
					</a-col>

				</a-row>
				<a-row>
					<a-form-model-item label="选择抄送人" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
						<ccChange :data="ccC" @targetKeys="getdata" v-if="isRouterAlive" />
					</a-form-model-item>
				</a-row>
				<a-row>
					<a-table :data-source="apply_info.old_goods" bordered :pagination="false">
						<a-table-column key="name" title="物品名称" ellipsis="true" data-index="name" />
						<a-table-column key="model" title="规格型号" ellipsis="true" data-index="model" />
						<a-table-column key="is_inspected" title="是否检定" data-index="is_inspected">
							<template scope="text">
								<span :style="{ color: colors[text] }">
									{{ instrumentMap[text] }}
								</span>
							</template>
						</a-table-column>
						<a-table-column key="amount" title="物品数量" ellipsis="true" data-index="amount" />
						<a-table-column key="delivery_amount" title="申领数量" data-index="delivery_amount" width="200px">
							<template scope="text,record">
								<a-input type="number" @blur="set_max_min(record)" v-model="record.delivery_amount" />
							</template>
						</a-table-column>
						<a-table-column key="unit" title="物品单位" data-index="unit" />
					</a-table>
				</a-row>
			</a-form-model>
		</a-modal>
		<a-modal title="耗材领用-详情" :visible="detailsvisible" @cancel="detailsvisible = false" width="55%">
			<template slot="footer">
				<a-button key="back" @click="detailsvisible = false"> 取消 </a-button>
			</template>
			<a-form-model :model="detailsrow" :label-col="labelCol" :wrapper-col="wrapperCol">
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="公司名称">
							<span>{{ detailsrow.company_name }}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="类别">
							<span>{{ detailsrow.spu_type_name }}</span>
						</a-form-model-item>
					</a-col>
					<!-- <a-col :span="12">
						<a-form-model-item label="物品编号">
							<span>{{ detailsrow.spu_sn }}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="物品名称">
							<span>{{ detailsrow.name }}</span>
						</a-form-model-item>
					</a-col> -->
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="品类编号">
							<span>{{ detailsrow.spu_sn }}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="品类名称">
							<span>{{ detailsrow.name }}</span>
						</a-form-model-item>
					</a-col>

				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="规格型号">
							<span>{{ detailsrow.model }}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="是否已检定">
							<span>{{ instrumentMap[detailsrow.is_inspected] }}</span>
						</a-form-model-item>
					</a-col>
					<!-- <a-col :span="12">
						<a-form-model-item label="物品数量">
							<span>{{ detailsrow.amount }}</span>
						</a-form-model-item>
					</a-col> -->
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="采购均价">
							<span>{{ detailsrow.price }}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="库存数量">
							<span>{{ detailsrow.amount }}</span>
						</a-form-model-item>
					</a-col>
					<!-- <a-col :span="12">
						<a-form-model-item label="物品单位">
							<span>{{ detailsrow.unit }}</span>
						</a-form-model-item>
					</a-col> -->
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="存放条件">
							<span>{{
								detailsrow.storage_cond ? detailsrow.storage_cond.replace('其他;', '').replace(/;/g,
									'、') : ''
							}}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="单位">
							<span>{{ detailsrow.unit }}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<!-- <a-row>
					<a-col :span="12">
						<a-form-model-item label="资产类别">
							<span>{{ detailsrow.spu_type_name }}</span>
						</a-form-model-item>
					</a-col>
					
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="公司名称">
							<span>{{ detailsrow.company_name }}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="备注">
							<span>{{ detailsrow.notes }}</span>
						</a-form-model-item>
					</a-col>
				</a-row> -->
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="是否为制毒、制爆">
							<span><span>{{
								detailsrow.hazard_type ? detailsrow.hazard_type.replace('其他;',
									'').replace(/;/g, '、') : ''
							}}</span></span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="备注">
							<span>{{ detailsrow.notes }}</span>
						</a-form-model-item>
					</a-col>
					<!-- <a-col :span="12">
						<a-form-model-item label="存放条件">
							<span>{{ detailsrow.storage_cond ? detailsrow.storage_cond.replace('其他;', '').replace(/;/g, '、') : '' }}</span>
						</a-form-model-item>
					</a-col> -->
				</a-row>
			</a-form-model>
		</a-modal>
	</div>
</template>

<script>
import debounce from 'lodash/debounce'
import {
	claim_apply,
	getDeptListEnable,
	consumablesList,

} from '@/api/assetmenag'
import {
	get_dict,
	returnDept2,
	get_users
} from '@/utils/unit_axios'
import {
	ACCESS_TOKEN
} from '@/store/mutation-types'
import ccChange from '@/components/module/ccChange'
import storage from 'store'
const deptMap = {}
export default {
	data() {
		return {
			statusMap: '',
			isRouterAlive: true,
			selectedRowKeysTab: [],
			selectedRowKeysTabItems: [],
			scroll_y: 150,
			deptMap,
			data: '',
			loading: false,
			name: '', //搜索关键字
			date: [],
			pagination: {
				current: 1,
				pageSize: 10,
				total: 0,
				pageSizeOptions: ['10', '20', '30', '40', '50'],
				showLessItems: true,
				showSizeChanger: true,
			},
			apply_rules: {
				reason: [{
					required: true,
					message: '请输入申领原因',
					trigger: 'blur',
				},],
			},
			is_apply_show: false,
			apply_info: {
				cc: [],
				cs: '',
				deptKey: '',
				reason: '', //
				remark: '',
				old_goods: [],
				goods: [],
			},
			labelCol: {
				xs: {
					span: 24,
				},
				sm: {
					span: 7,
				},
			},
			wrapperCol: {
				xs: {
					span: 24,
				},
				sm: {
					span: 16,
				},
			},
			labelCol2: {
				span: 2
			},
			wrapperCol2: {
				span: 22
			},
			options: [],
			checkAll: false,
			indeterminate: false,
			checkAllOptions: [], //全项
			detailsrow: '',
			detailsvisible: false,
			ccC: 'claim',
		}
	},
	components: {
		ccChange
	},
	filters: {
		operTypeFilter(type) {
			return operTypeMap[type].text
		},
		deptFilter(type) {
			return deptMap[type].text
		},
	},
	created() {
		this.get_list()
		get_dict('goodStatus', (res) => {
			console.log(res)
			this.statusMap = res
		})
		getDeptListEnable().then((res) => {
			const data = res.rows
			if (data.length > 0) {
				const min = Math.min(...data.map((m) => m.parentId))
				this.buildtree2(data, this.deptTree, min)
				this.deptTree.map((d) => {
					if (d.hasOwnProperty('children')) {
						d.children.map((b) => {
							deptMap[b.key] = {
								text: b.title,
							}
							deptMap[d.key] = {
								text: d.title,
							}
						})
					} else {
						deptMap[d.key] = {
							text: d.title,
						}
					}
				})
				this.expandedKeys = data.map((m) => m.parentId)
				this.dataList = data.map((m) => {
					return {
						key: m.deptId,
						title: m.deptName,
					}
				})
			}
		})
	},
	mounted() {
		returnDept2((res) => {
			this.options = res.depts
		})
		this.$nextTick(() => {
			var max_h = $('#content_main_center_scroll').height()
			setTimeout(() => {
				this.scroll_y = max_h - $('.ant-table-header').height() -40
			}, 1000)
		})
	},
	methods: {
		result() {
			this.name = ''
			this.selectedRowKeysTab = []
			this.selectedRowKeysTabItems = []
			this.serch()
		},
		getdata(data) {
			this.apply_info.cc = data
		},
		//搜索
		serch() {
			this.loading = true
			this.pagination.current = 1
			this.get_list()
		},
		//改变分页
		handleTableChange(pagination, filters, sorter) {
			this.pagination.current = pagination.current
			this.pagination.pageSize = pagination.pageSize
			this.get_list()
		},
		get_list() {
			this.loading = true
			// sku_spu
			consumablesList({
				sortField: 'id',
				sortOrder: 'desc',
				pageSize: this.pagination.pageSize,
				pageIndex: this.pagination.current,
				name: this.name,
				start_date: this.date.length ? this.date[0] : '',
				end_date: this.date.length ? this.date[1] : '',
			}).then((res) => {
				var arry = []
				res.data.list.forEach(item => {
					var a = {}
					a = {
						amount: item.storageNum,
						average_price: item.averagePrice,
						company_id: item.companyId,
						company_name: item.companyName,
						createBy: item.createBy,
						createTime: item.createTime,
						dept_id: item.deptId,
						hazard_type: item.hazardType,
						id: item.id,
						is_inspected: item.isInspected,
						is_inspected_name: item.isInspectedName,
						model: item.model,
						name: item.name,
						notes: item.notes,
						period: item.period,
						price: item.price,
						short_limit: item.shortLimit,
						spu_sn: item.spuSn,
						spu_type: item.spuType,
						spu_type_name: item.spuTypeName,
						storage_cond: item.storageCond,
						// storage_num: item.storageNum,
						unit: item.unit,
						updateBy: item.updateBy,
						updateTime: item.updateTime

					}
					arry.push(a)
				})
				this.loading = false
				const pagination = {
					...this.pagination
				}
				pagination.total = res.data.totalCount
				this.pagination = pagination
				this.data = arry
				// this.data.forEach((item) => {
				// 	item.price = item.price / 100
				// 	item.value = item.value / 100
				// 	item.amount = item.amount / 100
				// })
			})
		},
		//选择第一个表格
		onSelectChangeTab(selectedRowKeys, selectedRows) {
			var arr = JSON.parse(JSON.stringify(selectedRows))
			this.selectedRowKeysTabItems = this.selectedRowKeysTabItems.concat(arr)
			this.selectedRowKeysTab = selectedRowKeys
			var obj = {}
			this.selectedRowKeysTabItems = this.selectedRowKeysTabItems.reduce(function (item, next) {
				obj[next.id] ? '' : (obj[next.id] = true && item.push(next))
				return item
			}, [])
			var newLis = []
			this.selectedRowKeysTab.forEach((key, idx) => {
				this.selectedRowKeysTabItems.forEach((item, index) => {
					if (key == item.id) {
						newLis.push(item)
					}
				})
			})
			this.selectedRowKeysTabItems = newLis
			console.log(newLis)
		},
		show_apply() {
			this.isRouterAlive = false
			this.$nextTick(() => {
				this.isRouterAlive = true
			})
			this.apply_info = {
				cc: [],
				cs: '',
				deptKey: '',
				reason: '', //
				remark: '',
				old_goods: [],
				goods: [],
				// goodsId: '',

			}
			this.selectedRowKeysTabItems.forEach((item) => {
				item['delivery_amount'] = 1
				// item.goodsId = item.id

			})
			this.apply_info.old_goods = this.selectedRowKeysTabItems
			this.is_apply_show = true
		},
		//选择部门
		onChangeDept(value) {
			this.apply_info.cc = []
			this.checkAll = false
			this.apply_info.deptKey = value[1]
			get_users(value[1], (res) => {
				res.forEach((item) => {
					item['label'] = item.userName
					item['value'] = item.userId
				})
				this.checkAllOptions = res
			})
		},
		//全选改变
		onCheckAllChange(e) {
			var vs = []
			this.checkAllOptions.forEach((item) => {
				vs.push(item.value)
			})
			this.apply_info.cc = e.target.checked ? vs : []
			this.indeterminate = false
			this.checkAll = e.target.checked
		},
		// 某项改变
		onChangeFroup(checkedList) {
			this.indeterminate = !!checkedList.length && checkedList.length < this.checkAllOptions.length
			this.checkAll = checkedList.length === this.checkAllOptions.length
		},
		//限制最大值
		set_max_min(row) {
			let max = row.amount
			if (row.delivery_amount < 1) {
				row.delivery_amount = 1
			}
			if (row.delivery_amount > max) {
				row.delivery_amount = max
			}
			this.$forceUpdate()
		},
		//点击领用出库
		apply_delivery: debounce(function () {
			this.$refs.apply_ref.validate((valid) => {
				if (valid) {
					var is = true
					this.apply_info.old_goods.forEach((item) => {
						if (item.amount < 1) {
							is = false
						} else if (item.amount < item.delivery_amount) {
							is = false
						}
						this.apply_info.goods.push({
							goodsId: item.id,
							claimNum: item.delivery_amount
						})
					})
					if (!is) {
						this.$message.error('库存不足')
						return
					}
					this.apply_info.cc = this.apply_info.cc.length ? this.apply_info.cc.join(',') : ''
					claim_apply(this.apply_info).then((res) => {
						if (res.code != 200) {
							this.$message.error(res.msg)
							return
						}
						this.$message.success('申领成功')
						this.get_list()
						this.is_apply_show = false
					})
				} else {
					console.log('error submit!!')
					return false
				}
			})
		}, 1000, {
			'leading': true,
			'trailing': false
		}),
		details(row) {
			this.detailsvisible = true
			this.detailsrow = row
		},
	},
}
</script>

<style>
.dialog {
	display: flex;
	justify-content: space-between;
}

.flex {
	display: flex;
}

.center {
	text-align: center;
	width: 832px;
}

.dialog .dialog_item {
	margin-bottom: 5px;
	width: 220px;
	display: flex;
	justify-content: space-between;
}

.Exhi {
	display: inline-block;
	border: 1px solid black;
	width: 100px;
	text-align: left;
	color: steelblue;
}
</style>
